import React from 'react';
import { wrapCurrency } from '@/utils/common/number';
import { twMerge } from '@weee-fe/module';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  volumePrice?: string;
  price?: number | string;
  basePrice?: number | string;
  volumeThreshold?: number;
  className?: string;
  classes?: {
    container?: string;
    volumePrice?: string;
    volumeThreshold?: string;
    basePrice?: string;
    priceForOne?: string;
  };
};

export default function VolumePricing(props: Props) {
  const { volumePrice, volumeThreshold, price, basePrice, className, classes } = props;
  const { t } = useTranslation('common');
  return (
    <div data-testid="wid-product-card-volume-pricing" className={twMerge('-mt-[2px]', className)}>
      <div
        data-role="volume-price-container"
        className={twMerge(
          'h-[22px] w-fit pb-[2px] px-1 box-border flex items-end bg-[#FFD600] rounded-[4px] text-surface-100-fg-default whitespace-nowrap',
          classes?.container
        )}>
        <div className={twMerge('enki-body-base-strong !leading-[100%]', classes?.volumePrice)}>{`$${wrapCurrency(
          price
        )}`}</div>
        <div className={twMerge('enki-body-3xs-medium !tracking-normal !text-[10px] pb-0.5', classes?.volumeThreshold)}>
          {t('volume_add_abbreviation', { count: volumeThreshold })}
        </div>
      </div>
      <div
        data-testid="wid-product-card-volume-pricing-for-one"
        className={twMerge('mt-200 text-surface-100-fg-minor enki-body-3xs', classes?.priceForOne)}>
        {basePrice ? (
          <span className={twMerge('line-through', classes?.basePrice)}>{`$${wrapCurrency(basePrice)}`} </span>
        ) : (
          ''
        )}
        {t('volume_for_one', { count: wrapCurrency(volumePrice) })}
      </div>
    </div>
  );
}
